import { PropsWithChildren } from 'react';

export const AnalyticsProvider = ({ children }: PropsWithChildren) => <>{children}</>;
